import { render, staticRenderFns } from "./loanPermissions.vue?vue&type=template&id=ce062a60"
import script from "./loanPermissions.vue?vue&type=script&lang=js"
export * from "./loanPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports